import passions from "../constants/passions";
import products from "../constants/products";

//  -------------------------PASSIONS AND FEATURES--------------------------
const getFeaturesByPassion = (passionSelected) => {
  
  if(passionSelected == "todos"){
    const allPassions = []
   
    passions.forEach(({featuresByPassion})=> allPassions.push(...featuresByPassion))

    return {
      featuresByPassion:[...allPassions],
    }
  }
  return passions.find((passion) => passion.title === passionSelected);
}

const getFilterFeaturesByPassion = (name) => {
  const passion = passions.find((passion)=> passion.title == name)

  return passion?passion: false
}
getFilterFeaturesByPassion("todos")
//  -------------------------PRODUCTS--------------------------

const getSizes = (filter) => {
  const filterCopy = {...filter}
  delete filterCopy.size;
  const products = getProducts(filterCopy);
  return products.sizes;
}

const getFamilies = (filter) => {
  const families = [];
  const { filteredProducts: products } = getProducts(filter);

  products.forEach((product) => {
    if (!families.includes(product.family)) {
      families.push(product.family);
    }
  });

  return families;
}

const getProducts = (filter) => {


  const allProducts = products;
  let filteredProducts = [];
  const sizes = [];
  const priceRange = {
      min: Number.MAX_VALUE,
      max: 0,
  };

  const {
      passion,
      feature,
      size,
      price: {
          min: minPrice,
          max: maxPrice,
      } = {}
  } = filter;
 
  // Filter products
  Object.keys(allProducts).forEach((key) => {
      const model = allProducts[key];

      if(model.passions && model.passions.includes(passion)){
      
        if(feature){
          if (model.features && model.features.includes(feature)) {
            if (size) {
                if (model.size >= size[0] && model.size <= size[1] || model.inchTv === true) {
                    const priceNumber = Number(model.price);
                    if (minPrice && maxPrice) {
                        if (priceNumber >= minPrice && priceNumber <= maxPrice) {
                          filteredProducts.push(model)
                        
                        }
                    } else {
                      filteredProducts.push(model)
                    }
                }
            } else {
              filteredProducts.push(model);
            }
          }
        }else{
          filteredProducts.push(model);
        }
      }

      if(passion == "todos"){
        if (size) {
            if ((model.size >= size[0] && model.size <= size[1]) || model.inchTv === true) {
                const priceNumber = Number(model.price);
                if (minPrice && maxPrice) {
                    if (priceNumber >= minPrice && priceNumber <= maxPrice) {
                      filteredProducts.push(model)
                    
                    }
                } else {
                  filteredProducts.push(model)
                }
            }
        } else {
          filteredProducts.push(model);
        }
      }
  })

  // Extract sizes
  filteredProducts.forEach(({ size }) => {
      if (!sizes.includes(size)) {
          sizes.push(size)
      }
  })

  // Extract min/max price
  filteredProducts.forEach(({ price }) => {
      const priceNumber = Number(price);

      if (priceNumber < priceRange.min) {
          priceRange.min = priceNumber
      }

      if (priceNumber > priceRange.max) {
          priceRange.max = priceNumber;
      }
  });

  // if (!size){
    filteredProducts = groupProducts(filteredProducts);
  // }
  return {
      filteredProducts,
      sizes: sizes.sort(),
      price: priceRange
  };
};

const groupProducts = (productsToBeGrouped) => {
  const distinctProducts = [];
    const map = new Map();

    for(const product of productsToBeGrouped){
      if(!map.has(product.displayName)){
        map.set(product.displayName, true);
        let smallestSizeProduct = product;
        productsToBeGrouped.map(productOfSize => {
          if(smallestSizeProduct.displayName === productOfSize.displayName && productOfSize.size < smallestSizeProduct.size){
            smallestSizeProduct = productOfSize;
          }
        });
        distinctProducts.push(smallestSizeProduct);
      }
    }

   return distinctProducts;
}


export {getFilterFeaturesByPassion, getFeaturesByPassion, getSizes, getFamilies, getProducts, groupProducts };